import { initSentry } from "./lib/sentry";
import { clearStaleAppShells } from "./lib/staleAppCleanup";
// Initialize Sentry as early as possible, before any React code runs.
initSentry();
clearStaleAppShells();

import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

const root = document.getElementById("root");

if (root) {
  createRoot(root).render(
    <HelmetProvider>
      <App />
    </HelmetProvider>,
  );
}
